import { render, staticRenderFns } from "./trigger-flex-event.vue?vue&type=template&id=7c513009&"
import script from "./trigger-flex-event.vue?vue&type=script&lang=js&"
export * from "./trigger-flex-event.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports